// client/src/services/tenantQuotaService.js
// REST client for /api/quota and /api/admin/quota/*.

import { API_URL } from '../config.js';

function auth() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}
async function j(res) {
  const data = await res.json();
  if (!data.success) throw new Error(data.message || `HTTP ${res.status}`);
  return data;
}

const tenantQuotaService = {
  // Per-tenant view (admin or owner). Returns { quota, usage }.
  async get(plantId) {
    const r = await fetch(`${API_URL}/quota?plantId=${encodeURIComponent(plantId)}`, { headers: auth() });
    return j(r);
  },

  // Admin: read tier defaults so the UI can label "default for tier X"
  async tiers() {
    const r = await fetch(`${API_URL}/admin/quota/tiers`, { headers: auth() });
    return (await j(r)).tiers;
  },

  // Admin: upsert per-tenant overrides
  async save(plantId, body) {
    const r = await fetch(`${API_URL}/admin/quota/${encodeURIComponent(plantId)}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...auth() },
      body: JSON.stringify(body)
    });
    return (await j(r)).quota;
  }
};

export default tenantQuotaService;
